import { NewActionsEnum } from '../enums/NewActionsEnum';
import { INewsState } from '../interfaces/INewsState';
import { NewsAction } from '../types/NewsAction';

const initial: INewsState = {
  data: [],
  filterOption: '',
  sort: 'published,desc;created,desc;',
  page: 0,
};

export function newsReducer(state = initial, action: NewsAction) {
  switch (action.type) {
    case NewActionsEnum.NEWS_SET_DATA: {
      const newState: INewsState = {
        ...state,
        data: action.payload.data,
      };

      return newState;
    }
    case NewActionsEnum.NEWS_SET_FILTER_OPTION: {
      const newState: INewsState = {
        ...state,
        filterOption: action.payload.filterOption,
      };

      return newState;
    }
    case NewActionsEnum.NEWS_SET_ANNOUNCE: {
      const newState: INewsState = {
        ...state,
        announce: action.payload.announce,
      };

      return newState;
    }
    default:
      return state;
  }
}
